import {ButtonType} from 'antd/es/button';
import React, {FunctionComponent} from 'react';

import {SimpleActionButton, ISimpleActionButtonProps} from 'components/form/components';
import {useAppDispatch} from 'store/config/hooks';
import {openModal} from 'store/slices/modals-slice';

interface IButtonOpenModalProps extends Pick<ISimpleActionButtonProps, 'title' | 'icon'> {
    modalName: string;
    modalEntityName?: string;
    buttonType?: ButtonType;
}

export const ButtonOpenModal: FunctionComponent<IButtonOpenModalProps> = ({
    modalEntityName,
    modalName,
    buttonType,
    ...props
}: IButtonOpenModalProps) => {
    const dispatch = useAppDispatch();
    const handleClick = () => {
        dispatch(openModal({modalName, entityName: modalEntityName}));
    };
    return (
        <SimpleActionButton
            type={buttonType}
            onClick={handleClick}
            {...props}
        />
    );
};
